import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import styles from './GroupUserTable.module.css'; // 원하는 스타일 적용
import { Today } from '@mui/icons-material';
import sheetIcon from '../../../resources/images/data_table.svg';

const GroupUserTable = ({ groupId, users, onDeleteUsers, onAddUser, detailUser, onPrevPage, onNextPage, disablePrev, disableNext, pageNumber, totalCount, listSize, searchValue, setSearchValue, onSearch, isMobileWindow, products, createExcel }) => {
  const [selected, setSelected] = useState([]);
  const [sortField, setSortField] = useState('userId');
  const [sortOrder, setSortOrder] = useState('asc');
  const [searchType, setSearchType] = useState("product");
  // const {openModal} = useContext(ModalContext);

  const [userInfo, setUserInfo] = useState({
    userId: sessionStorage.getItem("userId"),
    userName: sessionStorage.getItem("userName"),
    groupId: sessionStorage.getItem("groupId"),
    role: sessionStorage.getItem("role")
  })

  // 정렬 처리
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  const sortedUsers = [...users].sort((a, b) => {
    let valA = a[sortField];
    let valB = b[sortField];
    // 날짜 비교
    if (sortField === "createdDate" || sortField === "lastConnectionDate") {
      valA = Number(valA) || 0;
      valB = Number(valB) || 0;
    }
    if (valA < valB) return sortOrder === "asc" ? -1 : 1;
    if (valA > valB) return sortOrder === "asc" ? 1 : -1;
    return 0;
  });

  // 체크박스 관련
  // const isAllSelected = selected.length === users.length && users.length > 0;
  const currentUserId = Number(sessionStorage.getItem("id")); // 필요 시
  const selectableIds = users
    .filter(u => u.status !== "active" && u.id !== currentUserId)
    .map(u => u.id);

  const isAllSelected = selectableIds.length > 0 && selectableIds.every(id => selected.includes(id));


  const handleSelectAll = () => {
    // setSelected(isAllSelected ? [] : users.map(u => u.id));

    // const selectableIds = users
    //   .filter(u => u.status !== "active")
    //   .map(u => u.id);

    // setSelected(isAllSelected ? [] : selectableIds);
    setSelected(isAllSelected ? [] : selectableIds);
  };

  const handleSelectRow = (id) => {
    // setSelected(selected.includes(id)
    //   ? selected.filter(i => i !== id)
    //   : [...selected, id]);

    // const user = users.find(u => u.id === id);
    // if (user?.status === "active") {
    //   alert("활성 상태인 사용자는 선택할 수 없습니다.");
    //   return;
    // }

    // setSelected(selected.includes(id)
    //   ? selected.filter(i => i !== id)
    //   : [...selected, id]);

    const user = users.find(u => u.id === id);
    if (!user || user.status === "active" || user.id === currentUserId) {
      alert("할당된 사용자는 삭제할 수 없습니다.");
      return;
    }

    setSelected(selected.includes(id)
      ? selected.filter(i => i !== id)
      : [...selected, id]);
  };

  // 삭제
  const handleDeleteSelected = () => {
    if (selected.length > 0) {
      onDeleteUsers(groupId, selected); // 리스트로 넘김
      setSelected([]);
    }
  };

  const handleSingleDelete = (id) => {
    onDeleteUsers([id]);
    setSelected(selected.filter(i => i !== id));
  };

  const transStatusView = (status) => {
    switch (status) {
      case 'active':
        return <span className={styles.badge} style={{ backgroundColor: '#4CAF50' }}>할당됨</span>;
      case 'deactive':
        return <span className={styles.badge} style={{ backgroundColor: '#9E9E9E' }}>미할당</span>;
      case 'expiration':
        return <span className={styles.badge} style={{ backgroundColor: '#F44336' }}>만료</span>;
      default:
        return status;
    }
  };

  const handleStatusChange = (e) => {
    setSearchType(e.target.value);
  };

  return (
    <div className={styles.tableSection}>
      <div className={styles.actionTopBar}>
        {/* 왼쪽: 검색 */}
        <div className={styles.actionBar}>
          <select name={"status"}
            className={styles.rightCont__cont__select} value={searchType}
            style={{ appearance: "auto", padding: '10px 10px', borderRadius: '4px', border: '1px solid #ccc' }}
            onChange={handleStatusChange}>
            <option value={"email"} defaultValue={true}>아이디</option>
            <option value={"userName"}>사용자</option>
            <option value={"status"}>상태</option>
          </select>
          <input
            className={styles.rightCont__cont__search}
            type="text"
            placeholder="아이디, 사용자 검색"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            style={{
              padding: '10px 20px',
              borderRadius: '4px',
              border: '1px solid #ccc'
            }}
          />
          <button
            onClick={() => onSearch(searchType, searchValue, groupId)}
            className={styles.addBtn}
            disabled={groupId.length === 0}
          >
            검  색
          </button>
        </div>
        <div className={styles.actionBar}>
          <button
            onClick={() => createExcel(groupId, searchType, searchValue)}
            className={styles.excelBtn}
            disabled={sortedUsers.length === 0}
            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
          >
            <img src={sheetIcon} />
            <p>Excel</p>
          </button>
          {userInfo.role == 'SYS_ADMIN' && (
            <>
              {/* 오른쪽: 버튼 묶음 */}

              <button
                onClick={handleDeleteSelected}
                className={styles.deleteBtn}
                disabled={selected.length === 0}
              >
                제  거
              </button>
              <button
                onClick={onAddUser}
                className={styles.addBtn}
                disabled={groupId.length === 0}
              >
                추  가
              </button>
            </>
          )}
        </div>
      </div>
      {/* <div className={styles.actionBar}> */}
      {/* {groupId !== "0" && ( */}
      {/* <>
        <button onClick={handleDeleteSelected} className={styles.deleteBtn} disabled={selected.length === 0}>제거</button>
        <button onClick={onAddUser} className={styles.addBtn}> 유저 추가 </button>
      </> */}
      {/* )} */}
      {/* </div> */}
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.checkboxCell}>
              <input
                className={styles.userCheckbox}
                type="checkbox"
                checked={isAllSelected}
                onChange={handleSelectAll}
              />
            </th>
            <th className={styles.idCol} onClick={() => handleSort('product')} style={{ cursor: 'pointer' }}>
              제품명 {sortField === 'product' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
            </th>
            {!isMobileWindow && (
              <th className={styles.idCol} onClick={() => handleSort('licenseGrade')} style={{ cursor: 'pointer' }}>
                요금제 {sortField === 'plan' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
              </th>
            )}
            <th className={styles.idCol} onClick={() => handleSort('email')} style={{ cursor: 'pointer' }}>
              아이디 {sortField === 'email' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
            </th>
            {/* <th className={styles.idCol} onClick={() => handleSort('password')} style={{cursor:'pointer'}}>
          비밀번호 {sortField === 'password' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
        </th> */}
            {!isMobileWindow && (
              <th className={styles.idCol} onClick={() => handleSort('userName')} style={{ cursor: 'pointer' }}>
                사용자 {sortField === 'userName' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
              </th>
            )}
            {/* <th className={styles.idCol} onClick={() => handleSort('startDate')} style={{cursor:'pointer'}}>
          시작일 {sortField === 'startDate' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
        </th> */}
            {!isMobileWindow && (
              <th className={styles.idCol} onClick={() => handleSort('endDate')} style={{ cursor: 'pointer' }}>
                잔여일 {sortField === 'endDate' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
              </th>
            )}
            <th className={styles.idCol} onClick={() => handleSort('status')} style={{ cursor: 'pointer' }}>
              상태 {sortField === 'status' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
            </th>
            {/* <th className={styles.authCol}>권한</th>
        <th className={styles.removeCol}>그룹 제거</th> */}
          </tr>
        </thead>
        <tbody>
          {sortedUsers.map((user) => (
            // <tr key={user.id} className={styles.tableRow} onClick={() => handleRowClick(user.id)}  style={{ cursor: "pointer" }}>
            <tr key={user.id} className={styles.tableRow} onClick={() => detailUser(user.id)} style={{ cursor: "pointer" }}>
              <td className={styles.checkboxCell}>
                <input
                  className={styles.userCheckbox}
                  type="checkbox"
                  checked={selected.includes(user.id)}
                  onClick={(e) => { e.stopPropagation() }}
                  onChange={(e) => {
                    handleSelectRow(user.id)
                  }}
                  disabled={user.status === "active" || user.id === currentUserId}
                />
              </td>
              <td className={styles.idCol}>{products[user.product]?.name}</td>
              {!isMobileWindow && (
                <td className={styles.idCol}>
                  {
                    products[user.product]?.plans.find(p => String(p.id) === String(user.plan))?.plan || '알 수 없음'
                  }
                </td>
              )}
              <td className={styles.idCol}>{user.email}</td>
              {/* <td className={styles.idCol}>{user.password}</td> */}
              {!isMobileWindow && (
                <td className={styles.idCol}>{user.userName}</td>
              )}
              {/* <td>{user.startDate ? dayjs(Number(user.startDate)).format('YYYY-MM-DD') : '-'}</td> */}
              {!isMobileWindow && (
                // <td>{user.endDate ? dayjs(Number(user.endDate)).format('YYYY-MM-DD') : '-'}</td>
                <td>
                  {Math.max(0, Math.trunc((user.endDate - Date.now()) / (1000 * 3600 * 24)))}일
                </td>
              )}
              <td className={styles.idCol}>{transStatusView(user.status)}</td>
            </tr>
          ))}
          {users.length === 0 && (
            <tr>
              {!isMobileWindow ?
                (<td colSpan={7} style={{ textAlign: "center", color: "#888" }}>유저가 없습니다.</td>) :
                (<td colSpan={4} style={{ textAlign: "center", color: "#888" }}>유저가 없습니다.</td>)
              }
            </tr>
          )}
        </tbody>
      </table>
      <div className={styles.actionBar} style={{ marginTop: "8px" }}>
        <>
          {totalCount > 0 && (
            <p className={styles.text} >{pageNumber * listSize + 1} - {Math.min((pageNumber * listSize + 1) + listSize - 1, totalCount)} of {totalCount} </p>
          )}
          <button className={styles.addBtn} onClick={onPrevPage} disabled={disablePrev}>{"<"}</button>
          <button className={styles.addBtn} onClick={onNextPage} disabled={disableNext}>{">"}</button>
        </>
      </div>
    </div>
  );
};

export default GroupUserTable;
